import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { DialogContent, DialogActions, Button } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { Skeleton } from '@material-ui/lab';

const useStyles = makeStyles(theme => ({
  root: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2)
  },
  dateFieldContainer: {
    display: 'flex',
    gap: theme.spacing(2),
    marginBottom: theme.spacing(1)
  },
  checkboxRow: {
    marginTop: theme.spacing(1)
  },
  allocationRow: {
    marginTop: theme.spacing(2)
  }
}));

const SetResourceAllocationDialogLoadingState = ({ onClose }) => {
  const classes = useStyles();

  return (
    <>
      <DialogContent className={classes.root}>
        <div className={classes.dateFieldContainer}>
          <Skeleton variant="rect" height={56} width="100%" />
          <Skeleton variant="rect" height={56} width="100%" />
        </div>
        <div className={classes.checkboxRow}>
          <Skeleton height={36} width="60%" />
        </div>
        <div className={classes.allocationRow}>
          <Skeleton height={48} width="100%" />
          <Skeleton height={56} width="100%" />
        </div>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="contained">
          <FormattedMessage id="setResourceAllocationDialog.cancel" />
        </Button>
        <Button color="primary" variant="contained" disabled>
          <FormattedMessage id="setResourceAllocationDialog.setResourceAllocation" />
        </Button>
      </DialogActions>
    </>
  );
};

SetResourceAllocationDialogLoadingState.propTypes = {
  onClose: PropTypes.func.isRequired
};

export default SetResourceAllocationDialogLoadingState;
